import React from 'react';
import { Link } from 'react-router-dom';
import { splitLongText } from 'helpers/text';

const UserList = ({ users, childAccounts }) => (
  <table className="table table-striped">
    <thead>
      <tr>
        <th>ID</th>
        <th>First Name</th>
        <th>Last Name</th>
        <th>Email</th>
        {childAccounts ? '' : <th>Role</th>}
        <th></th>
      </tr>
    </thead>
    <tbody>
      {users.map((user) => (
        <tr key={user.id}>
          <td>{user.id}</td>
          <td>{splitLongText(user.first_name)}</td>
          <td>{splitLongText(user.last_name)}</td>
          <td>{splitLongText(user.email, 40)}</td>
          {childAccounts ? '' : <td>{user.acl_group_name}</td>}
          <td>
            <Link to={`/users/${user.id}/view`}>View</Link>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default UserList;
